import PropTypes from 'prop-types';
import { memo } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Tooltip from 'shopper/components/Tooltip';

import placeholder from 'lib/placeholder';

const LikeButton = ({ children, isLiked, onClick }) => (
  <Tooltip.Root>
    <Tooltip.Trigger>
      <Button
        iconLeft={<Icon name={isLiked ? 'like-filled' : 'like'} />}
        size="size4"
        type="neutral-ghost"
        onClick={onClick}
      >
        {children}
      </Button>
    </Tooltip.Trigger>
    <Tooltip.Box align="left" className="z-2 w-max">
      {isLiked ? placeholder('tips.liked') : placeholder('tips.like')}
    </Tooltip.Box>
  </Tooltip.Root>
);

LikeButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLiked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default memo(LikeButton);
